import {Component, computed, input, Signal, ChangeDetectionStrategy} from '@angular/core';
import lodash from "lodash";
import {DatePipe, NgClass} from "@angular/common";
import {PortVisitCommonModule} from "../../../common/port-visit-common.module";
import {HighlightComponent} from "../../../common/typeahead/highlight/highlight.component";
import {nonNull} from "../../../common/utils";
import {VisitStatus} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
  selector: 'app-movement-icons',
  templateUrl: './movement-icons.component.html',
  imports: [
    DatePipe,
    PortVisitCommonModule,
    NgClass,
    HighlightComponent
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './movement-icons.component.scss'
})
export class MovementIconsComponent {
  readonly movements = input<MovementInfo[]>([]);
  readonly term = input<string>();
  readonly middleStatus = input<ArrivalStatus | string>(null);
  readonly showDate = input<boolean>(true);
  readonly hasMiddleRow = input<boolean>(true);
  readonly allMiddleMovements = input<boolean>(false);
  readonly plain = input<boolean>(false);

  readonly firstMovement: Signal<MovementInfo> = computed(() => this.allMiddleMovements() ? null : lodash.first(this.movements()));
  readonly lastMovement: Signal<MovementInfo> = computed(() => this.allMiddleMovements() ? null : lodash.last(this.movements()));
  readonly middleMovements = computed(() => this.allMiddleMovements() ? this.movements() : this.movements().slice(1, -1));
  readonly currentMiddleMovements = computed<MovementInfo[] | null>(() => {
    if (this.hasMiddleRow() && this.allMiddleMovements()) {
      return this.middleMovements().slice(0, 3);
    } else if (this.allMiddleMovements()) {
      return this.middleMovements().slice(0, 2);
    } else {
      return [lodash.findLast(this.middleMovements(), m => m.arrivalStatus === ArrivalStatus.arrived)
        ?? this.middleMovements()[0] ?? null].filter(nonNull);
    }
  });
  readonly showAsRows = computed(() => this.allMiddleMovements() && this.currentMiddleMovements()?.length === 1);
  readonly showMore = computed(() => this.middleMovements().length > (this.allMiddleMovements() ? 2 : 1));
}

export enum ArrivalStatus {
  expected = "expected",
  arrived = "arrived",
  departed = "departed"
}

export interface MovementInfo {
  arrivalStatus: ArrivalStatus;
  date: string;
  name: string;
  tooltip?: string;
}

export function fromVisitStatus(status: VisitStatus): ArrivalStatus {
  switch (status) {
    case VisitStatus.DEPARTED: return ArrivalStatus.departed;
    case VisitStatus.ARRIVED: return ArrivalStatus.arrived;
    case VisitStatus.EXPECTED: return ArrivalStatus.expected;
  }
}
